module.exports = __webpack_public_path__ + "static/media/cart-icon.b04471ad.svg";